// 企業関連の型定義

export enum BusinessType {
  SALES_BROKERAGE = '売買仲介',
  RENTAL_BROKERAGE = '賃貸仲介',
  DEVELOPMENT = '開発',
  PROPERTY_MANAGEMENT = '管理',
  INVESTMENT = '投資',
  CONSULTING = 'コンサルティング',
  OTHER = 'その他',
}

export enum EmployeeCountRange {
  SMALL = '1-10名',
  MEDIUM = '11-50名',
  LARGE = '51-200名',
  XLARGE = '201名以上',
}

export enum CompanyStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  SUSPENDED = 'suspended',
}

// 企業登録フォームデータ
export interface CompanyRegistrationData {
  companyName: string;
  representativeName: string;
  prefecture: string;
  city: string;
  businessType: BusinessType;
  employeeCountRange: EmployeeCountRange;
  contactEmail: string;
  password: string;
  confirmPassword: string; // パスワード確認用（APIには送信しない）
  agreedToTerms: boolean;
  agreedToPrivacy: boolean;
}

// 企業登録APIリクエスト
export interface CompanyRegistrationRequest {
  companyName: string;
  representativeName: string;
  prefecture: string;
  city: string;
  businessType: BusinessType;
  employeeCountRange: EmployeeCountRange;
  contactEmail: string;
  password: string;
  agreedToTerms: boolean;
  agreedToPrivacy: boolean;
}

// 企業登録APIレスポンス（成功）
export interface CompanyRegistrationResponse {
  success: true;
  data: {
    companyId: number;
    status: CompanyStatus.PENDING;
    message: string;
    estimatedReviewDays?: number;
  };
}

// 企業登録APIレスポンス（エラー）
export interface CompanyRegistrationErrorResponse {
  success: false;
  error: {
    code:
      | 'VALIDATION_ERROR'
      | 'EMAIL_ALREADY_EXISTS'
      | 'INVALID_COMPANY_NAME'
      | 'WEAK_PASSWORD';
    message: string;
    details?: ValidationError[];
    timestamp: string;
  };
}

// バリデーションエラー
export interface ValidationError {
  field: string;
  message: string;
}

// 企業基本情報
export interface Company {
  id: number;
  companyName: string;
  representativeName: string;
  prefecture: string;
  city: string;
  businessType: BusinessType;
  employeeCountRange: EmployeeCountRange;
  contactEmail: string;
  status: CompanyStatus;
  createdAt: string;
  updatedAt: string;
  approvedAt?: string;
  approvedBy?: number;
  rejectionReason?: string;
}

// フォームエラー状態
export interface CompanyRegistrationFormErrors {
  companyName?: string;
  representativeName?: string;
  prefecture?: string;
  city?: string;
  businessType?: string;
  employeeCountRange?: string;
  contactEmail?: string;
  password?: string;
  agreedToTerms?: string;
  agreedToPrivacy?: string;
}

// フォーム送信状態
export interface CompanyRegistrationFormState {
  isSubmitting: boolean;
  submitError: string | null;
  showSuccessDialog: boolean;
  registeredCompanyId: number | null;
}
